(function () {
    const header = document.querySelector('#site-header')
    const bar = header?.querySelector('div:first-child')

    if (!bar) {
        return
    }

    window.addEventListener('scroll', () => {
        let { top } = bar.getBoundingClientRect()
        if (document.body.classList.contains('admin-bar')) {
            const style = window.getComputedStyle(document.body)
            top -= style.getPropertyValue('--admin-bar-height').replace('px', '')
        }
        const { scrollY } = window

        if (scrollY > 0 && top === 0) {
            document.documentElement.classList.add('has-sticky-header')
        }

        if (scrollY === 0) {
            document.documentElement.classList.remove('has-sticky-header')
        }
    })
})()
